import React, { useState } from 'react'
import HomeIcon from '@mui/icons-material/Home'
import SavedSearchIcon from '@mui/icons-material/SavedSearch';
import ExploreIcon from '@mui/icons-material/Explore';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import SmsIcon from '@mui/icons-material/Sms';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import FacebookIcon from '@mui/icons-material/Facebook';
import MenuIcon from '@mui/icons-material/Menu';
import './leftSide.css'
import Profile from '../assets/profile.png'
import logo from '../assets/logo.png'

const LeftSide = () => {

  // const [active, setActive] = useState('home')

  return (
    <div className="leftSidePart">

      {/* LOGO */}
      <div className="logoPart">
        <img src={logo} alt="Rapchik Logo" className="logoimg" />
      </div>

      {/* NAV LINKS */}
      <div className="navLinkPart">
          {/* HomePart */}
        <div className="navLink">
          <HomeIcon sx={{fontSize:"30px" ,margin:"0 20px 0 0",padding:"20"}} />
          <span className="navName">Home</span>
        </div>

        <div className="navLink">
          <SavedSearchIcon sx={{fontSize:"30px" ,margin:"0 20px 0 0",padding:"20"}} />
          <span className="navName">Search</span>
        </div>

        <div className="navLink">
          <ExploreIcon sx={{fontSize:"30px" ,margin:"0 20px 0 0",padding:"20"}} />
          <span className="navName">Explore</span>
        </div>

        <div className="navLink">
          <OndemandVideoIcon  sx={{fontSize:"30px" ,margin:"0 20px 0 0",padding:"20"}} />
          <span className="navName">Reels</span>
        </div>

        <div className="navLink">
          <SmsIcon sx={{fontSize:"30px" ,margin:"0 20px 0 0",padding:"20"}} />
          <span className="navName">Messages</span>
        </div>

        <div className="navLink">
          <FavoriteBorderIcon sx={{fontSize:"30px" ,margin:"0 20px 0 0",padding:"20"}} />
          <span className="navName">Notifications</span>
        </div>

        <div className="navLink">
          <AddCircleOutlineIcon sx={{fontSize:"30px" ,margin:"0 20px 0 0",padding:"20"}} />
          <span className="navName">Create</span>
        </div>

        <div className="navLink">
          <img src={Profile} alt='ProfileImg' className='Profile'/>
          <span className="navName">Profile</span>
        </div>
       
      </div>

      <div className='belowPart'></div>
        <div className="navLink">
          <FacebookIcon sx={{fontSize:"30px" ,margin:"0 20px 0 0",padding:"20"}} />
          <span className="navName">Facebook</span>
        </div>

        <div className="navLink">
          <MenuIcon  sx={{fontSize:"30px" ,margin:"0 20px 0 0",padding:"20"}} />
          <span className="navName">More</span>
        </div>

    </div>
  )
}

export default LeftSide
